module.exports = __webpack_public_path__ + "img/zhongxinGH6.c4691a73.png";